module.exports = __webpack_public_path__ + "img/jcsjx-content.c5867f7c.png";